import Login from "./components/login.vue";
import Rate from "./components/vote_screen.vue";
import Error from "./components/other/404.vue";
import ThankCreateNote from "./components/other/thankCreateNote.vue";
import Place from "./components/place.vue";
import List from "./components/list.vue";
import adminPanel from "./components/admin/admin_panel.vue";
import QRquestions from "./components/admin/admin_panel--list.vue";
import OwnerPlaceManagement from "./components/owner-management/ownerPlaceManagement.vue";
import OwnerPlaceManagementStatus from "./components/owner-management/ownerPlaceManagement.vue";
import ProfileSettings from "./components/owner-management/managerSettings.vue";
import Privacy from "./components/other/privacy-policy.vue";
import ownerBusinessFlow from "./components/owner-management/ownerBusinessFlow";
import adminAddPlaceQFlow from "./components/owner-management/adminAddPlaceQFlow.vue";
import confirmEmail from "./components/auth/confirmEmail.vue";
import loadPdf from "./components/admin/loadPdf.vue";
import orderPage from "./components/owner-management/orderPage.vue"
import orderSuccess from "./components/owner-management/orderSuccess.vue"
import QuestionManageScreen from "./components/question_manage_screen"
import resetPasswordFlow from "./components/widgets/resetPasswordFlow";
import driverFlow from "./components/other/driverFlow";
import singlePageForClient from "./components/other/singlePageForClient";
import singleEmailSignaturePage from "./components/widgets/singleEmailSignaturePage";
import AirLeadDashboard from "./components/owner-management/airLeadDashboard";
import ServiceLogsDashboard from "./components/owner-management/serviceLogsDashboard";
import MapDashboard from "./components/owner-management/mapDashboard";
import QuestionsMap from "./components/questionsMap";
import AirLead from "./components/AirLead.vue"
import AirLeadSuccess from "./components/AirLeadSuccess.vue"
import HubspotRequest from "./components/HubspotRequest.vue"
import HubspotRequestSuccess from "./components/HubspotRequestSuccess.vue"
import ServiceRequest from "./components/ServiceRequest.vue"
import ServiceRequestSuccess from "./components/ServiceRequestSuccess.vue"
import ServiceRequestAuth from "./components/ServiceRequestAuth.vue"
import ServiceRequestNoAccess from "./components/ServiceRequestNoAccess.vue"
import SREntryPoint from "./components/SREntryPoint.vue"
import SREntryPointAuth from "./components/SREntryPointAuth.vue"
import SREntryPointNoAccess from "./components/SREntryPointNoAccess.vue"
import Mantera from "./components/promo/Mantera.vue"
import GoogleSignInResult from "./components/GoogleSignInResult.vue"
//layout
import MyBusinessLayout from "./components/owner-management/layout";
import MainLayout from "./components/mainLayout";
import unsubscribeFlow from "./components/other/unsubscribeFlow";
import croAuthCallback from "./components/other/croAuthCallback";
import hubspotAuthCallback from "./components/other/hubspotAuthCallback";
import Places from "./components/admin/tabs/Places";
import UnlinkedQuestions from "./components/admin/tabs/UnlinkedQuestions";
import Organization from "./components/admin/tabs/Organization";
import Votes from "./components/admin/tabs/Votes";
import Profiles from "./components/admin/tabs/Profiles";
import closeAccountRequests from "./components/admin/tabs/closeAccountRequests";
import landingQuestions from "./components/admin/tabs/landingQuestions";
import shortLinks from "./components/admin/tabs/shortLinks";
import landingFiles from "./components/admin/tabs/landingFiles";
import subscriptions from "./components/admin/tabs/subscriptions";
import serviceRequests from "./components/admin/tabs/serviceRequests";
import userActions from "./components/admin/tabs/userActions";
import locationIssues from "./components/admin/tabs/locationIssues";
import pdfGeneration from "./components/admin/tabs/pdfGeneration";
import secondLevelDetailsConfig from "./components/widgets/SecondLevelDetailsConfig";
import serviceLogConfig from "./components/widgets/ServiceLogConfig";
import dashboardSecondLevelDetails from "./components/owner-management/dashboardSecondLevelDetails";
import RateDetailsPublic from "./components/rateDetailsPublic/rateDetailsPublic";
import SecondLevelDetails from "./components/admin/tabs/SecondLevelDetails";
import dashboardServiceLog from "./components/owner-management/dashboardServiceLog";
import PayPaypalSubscription from "@/components/payPaypalSubscription";

const routes = [
    {
        path: "/sign-in",
        alias: ["/sign-up", "/forgot-password"],
        component: Login,
        name: "Login",
        props: {
            mgs: "",
            error_obj: undefined
        },
        children: [
            {
                name: "Specific login",
                path: ":provider",
                component: Login
            },
            {
                name: "Questions",
                path: "questions/:questions",
                component: Login
            }
        ]
    },
    {
        path: "/rate/:id",
        component: Rate,
        name: "Rate",
        meta: {
            checkIfVoted: true
        },
        children: [
            {
                name: "Rate-selected",
                path: ":number",
                component: Rate
            }
        ]
    },

    {
        path: "/thank-for-vote/:questionId",
        component: ThankCreateNote,
        name: "ThanksCreateNote",
        children: [
            {
                name: "Rate-selected",
                path: ":number/:rateUid",
                component: ThankCreateNote
            }
        ]
    },

    {
        path: "/own-business",
        component: ownerBusinessFlow,
        name: "ownerBusinessFlow",
    },
    {
        path: "/admin-add-place",
        component: adminAddPlaceQFlow,
        name: "adminAddPlaceQFlow",
    },
    // {
    //     path: "/users/:user_guid/unsubscribe?token=:user_token",
    //     component: unsubscribeFlow,
    //     name: "unsubscribeFlow",
    // },
    {
        path: "/unsubscribe/:user_guid",
        component: unsubscribeFlow,
        name: "unsubscribeFlow",
    },
    {
        path: "/auth/crosoftware/callback",
        component: croAuthCallback,
        name: "croAuthCallback",
    },
    {
        path: "/auth/hubspot/callback",
        component: hubspotAuthCallback,
        name: "hubspotAuthCallback",
    },
    {
        path: "/reset-password/:reset_code",
        component: resetPasswordFlow,
        name: "resetPasswordFlow",
        children: [
            {
                path: ":confirm",
                component: resetPasswordFlow,
                name: "resetPasswordFlow-confirm"
            },
            {
                path: ":cancel",
                component: resetPasswordFlow,
                name: "resetPasswordFlow-cancel"
            }
        ]
    },

    {path: "/", component: Login, name: "Login"},
    {
        path: "/",
        component: MainLayout,
        name: "layout",
        children: [
            {path: "/list", component: List, name: "list"},
            {
                path: "/admin",
                component: adminPanel,
                name: "adminPanel",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/places",
                component: Places,
                name: 'Places',
                meta: {adminPanel: true}
            },
            {
                path: "/admin/unlinkedQuestions",
                component: UnlinkedQuestions,
                name: 'unlinkedQuestions',
                meta: {adminPanel: true}
            },
            {
                path: "/admin/organization",
                component: Organization,
                name: 'organization',
                meta: {adminPanel: true}
            },
            {
                path: "/admin/votes",
                component: Votes,
                name: 'votes',
                meta: {adminPanel: true},
            },
            {
                path: "/admin/profiles",
                component: Profiles,
                name: "profiles",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/closeAccountRequests",
                component: closeAccountRequests,
                name: "closeAccountRequests",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/landingQuestions",
                component: landingQuestions,
                name: "landingQuestions",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/shortLinks",
                component: shortLinks,
                name: "shortLinks",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/landingFiles",
                component: landingFiles,
                name: "landingFiles",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/subscriptions",
                component: subscriptions,
                name: "subscriptions",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/service-requests",
                component: serviceRequests,
                name: "serviceRequests",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/users/actions",
                component: userActions,
                name: "userActions",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/location-issues",
                component: locationIssues,
                name: "locationIssues",
                meta: {adminPanel: true}
            },
            {
                path: "/admin/pdfGeneration",
                component: pdfGeneration,
                name: "pdfGeneration",
                meta: {adminPanel: true}
            },
            {
                path: "admin/questions/:id",
                component: QRquestions,
                name: "QRquestions",
                meta: {
                    adminPanel: true,
                    keepAlive: true
                }
            },
            {
                path: "admin/secLevelDetails/:orgUid/:uid",
                component: secondLevelDetailsConfig,
                name: "secondLevelDetailsConfig",
                meta: {adminPanel: true}
            },
            {
                path: "admin/service-log/:orgUid/:uid",
                component: serviceLogConfig,
                name: "serviceLogConfig",
                meta: {adminPanel: true}
            },
            {path: "/privacy-policy", component: Privacy, name: "Privacy"},
            { path: '/place-management', redirect: '/dashboard' },
            { path: '/place-management/:status', redirect: '/dashboard/:status' },
            {
                path: "/dashboard/",
                component: MyBusinessLayout,
                name: "myBusiness",
                children: [
                    {
                        path: "/dashboard",
                        component: OwnerPlaceManagement,
                        name: "OwnerPlaceManagement",
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        },
                    },
                    {
                        path: "/dashboard/:status",
                        component: OwnerPlaceManagementStatus,
                        name: "OwnerPlaceManagementStatus",
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        },
                    },
                    {
                        path: "/settings",
                        component: ProfileSettings,
                        name: "ProfileSettings",
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        },
                    },
                    {
                        path: "/order",
                        component: orderPage,
                        name: "orderPage",
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        },
                    },
                    {
                        path: "/orderSuccess",
                        component: orderSuccess,
                        name: "orderSuccess",
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        }
                    },
                    {
                        path: "/airLead",
                        component: AirLeadDashboard,
                        name: "AirLeadDashboard",
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        }
                    },
                    {
                        path: "/sld/:orgUid/:uid",
                        component: dashboardSecondLevelDetails,
                        name: "dashboardSecondLevelDetailsPlaces",
                        children: [
                            {
                                path: "/sld/:orgUid/:uid/:questionUid",
                                component: dashboardSecondLevelDetails,
                                name: "dashboardSecondLevelDetailsQuestions",
                                meta: {
                                    hideToolbar: true,
                                }
                            }
                        ],
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        }
                    },
                    {
                        path: "/sl/:orgUid/:uid",
                        component: dashboardServiceLog,
                        name: "dashboardServiceLogPlaces",
                        children: [
                            {
                                path: "/sl/:orgUid/:uid/:questionUid",
                                component: dashboardServiceLog,
                                name: "dashboardServiceLogQuestions",
                                meta: {
                                    hideToolbar: true,
                                }
                            }
                        ],
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        }
                    },
                    {
                        path: "/serviceLogs",
                        component: ServiceLogsDashboard,
                        name: "ServiceLogsDashboard",
                        meta: {
                            adminPanel: true,
                            keepAlive: true,
                            hideToolbar: true,
                            requiresAuth: true
                        }
                    }

                ]
            },
            {
                path: "/map",
                component: MapDashboard,
                name: "MapDashboard",
                meta: {
                    adminPanel: true,
                    keepAlive: true,
                    hideToolbar: true,
                    requiresAuth: true
                }
            },
            {
                path: '/driver',
                component: driverFlow,
                name: "driverFlow",
                meta: {
                    hideToolbar: true
                }
            },
            {
                path: '/noacc',
                component: singlePageForClient,
                name: "noacc",
                meta: {
                    hideToolbar: true
                }
            },
            {
                path: "/questions/:questionId/manage",
                component: QuestionManageScreen,
                name: "QuestionManageScreen",
                meta: {
                    hideToolbar: true,
                    requiresAuth: true
                }
            },
        ]
    },

    {path: "/place/:id", component: Place, name: "place"},
    {
        path: "/auth/confirm-email/:confirmUid",
        component: confirmEmail,
        name: "confirmEmail",
    },
    {
        path: "/subscriptions/:templateTag/pay",
        component: PayPaypalSubscription,
        name: "payPaypalSubscription",
    },
    {
        path: "/load-pdf/:pdfUid",
        component: loadPdf,
        name: "loadPdf",
    },
    {
        path: '/questions/:guid/e-signature/',
        component: singleEmailSignaturePage,
        name: 'singleEmailSignaturePage',
    },
    {
        path: "/questions/:questionId/airlead/:type",
        component: AirLead,
        name: 'AirLead',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/airlead-success",
        component: AirLeadSuccess,
        name: 'AirLeadSuccess',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/auth/google/result",
        component: GoogleSignInResult,
        name: 'GoogleSignInResult',
        meta: {
            hideToolbar: true,
            requiresAuth: false,
        }
    },
    {
        path: "/airlead-h/:place_guid/:type",
        component: HubspotRequest,
        name: 'HubspotServiceRequest',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/airlead-h-success",
        component: HubspotRequestSuccess,
        name: 'HubspotRequestSuccess',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/questions/:questionId/service/:type",
        component: ServiceRequest,
        name: 'ServiceRequest',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/service-request-success",
        component: ServiceRequestSuccess,
        name: 'ServiceRequestSuccess',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/questions/:questionId/service/:type/auth",
        component: ServiceRequestAuth,
        name: 'ServiceRequestAuth',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/questions/:questionId/service/:type/no-access",
        component: ServiceRequestNoAccess,
        name: 'ServiceRequestNoAccess',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/sre/:orgGuid",
        component: SREntryPoint,
        name: 'SREntryPoint',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/sre/:orgGuid/auth",
        component: SREntryPointAuth,
        name: 'SREntryPointAuth',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/sre/:orgGuid/no-access",
        component: SREntryPointNoAccess,
        name: 'SREntryPointNoAccess',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/happy-fathers-day",
        component: Mantera,
        name: 'Mantera',
        meta: {
            hideToolbar: true,
            requiresAuth: true
        }
    },
    {
        path: "/votedetails/:uid",
        component: RateDetailsPublic,
        name: 'RateDetailsPublic',
        meta: {
            hideToolbar: true,
            requiresAuth: false
        }
    },
    {
        path: "/places/:hash/map",
        component: QuestionsMap,
        name: 'QuestionsMap',
        meta: {
            hideToolbar: true,
            requiresAuth: false
        }
    },
    {path: "/*", component: Error, name: "404",
        meta: {
            hideToolbar: true,
            requiresAuth: false,
            adminPanel: false,
        }}
];

export default routes;
